import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import GroupsListItem from '../GroupsListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="groupsView" itemLayout={GroupsListItem} />
	}
];

export default tabs;
